// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2swlT","newExpiryDate":"styles_newExpiryDate__1Q3V6","footer":"styles_footer__2qlR_"};